// toast.service.ts
import { Injectable, TemplateRef } from '@angular/core';
import { v4 as uuid } from 'uuid';
import { ToastMessage2, ToastMessageData2, ToastMessageOptions2 } from '@app/shared/toast/models/custom-toast-models';
import { SafeHtml } from '@angular/platform-browser';

@Injectable()
export class ToastServicev2 {
  toasts: ToastMessage2[] = [];

  private readonly defaultOptions: ToastMessageOptions2 = { autohide: true, delay: 4000 };
  private readonly toastColors: Record<number, ToastMessageOptions2> = {
    200: { classes: 'bg-success text-white', headerClasses: 'text-white', bodyClasses: 'text-white' },
    201: { classes: 'bg-success text-white', headerClasses: 'text-white', bodyClasses: 'text-white' },
    400: { classes: 'bg-danger text-white', headerClasses: 'text-white', bodyClasses: 'text-white' },
    401: { classes: 'bg-danger text-white', headerClasses: 'text-white', bodyClasses: 'text-white' },
    403: { classes: 'bg-danger text-white', headerClasses: 'text-white', bodyClasses: 'text-white' },
    404: { classes: 'bg-danger text-white', headerClasses: 'text-white', bodyClasses: 'text-white' },
    409: { classes: 'bg-warning text-dark', headerClasses: 'text-dark', bodyClasses: 'text-dark' },
    500: { classes: 'bg-danger text-white', headerClasses: 'text-white', bodyClasses: 'text-white' }
  };

  // Hold default template references
  defaultHeaderTemplate: TemplateRef<any> | null = null;
  defaultBodyTemplate: TemplateRef<any> | null = null;

  // workaround the options params is not rendered in the template
  toastParams: ToastMessageOptions2 | null = null;

  constructor() {}

    // Called by the ToastContainerComponent on initialization
  setDefaultTemplates(headerTemplate: TemplateRef<any>, bodyTemplate: TemplateRef<any>): void {
    this.defaultHeaderTemplate = headerTemplate;
    this.defaultBodyTemplate = bodyTemplate;
  }

  showToast(header: string, body: string | SafeHtml, options: ToastMessageOptions2 = {}): void {

    const toastID = uuid();
    const context = {
      toastService: this,
      toastID,
      params: {
        title: header,
        bodyText: body,
        timestamp: new Date().toLocaleTimeString()
      }
    };

    const toast: ToastMessage2 = {
      header: this.defaultHeaderTemplate!,
      body: this.defaultBodyTemplate!,
      uuid: toastID,
      options: { ...this.defaultOptions, ...options, context }
    };

    this.toasts.push(toast);

    if (toast.options && toast.options.autohide) {
      setTimeout(() => this.remove(toast.uuid), toast.options.delay);
    }
  }

  remove(toastID: string): void {
    this.toasts = this.toasts.filter(t => t.uuid !== toastID);
  }

  showSuccess(header: string, body: string | SafeHtml, delay?: number): void {
    // this.show('Success', { autohide: true, delay: 1000, ...options });
    const options: ToastMessageOptions2 = {
      autohide: true,
      delay: delay || 3500,
      params: {
        title: header,
        timestamp: new Date().toLocaleTimeString(),
        bodyText: body,
        iconName: 'check-circle',       // feather icon for success
        headerClass: 'text-success fw-bold'
      }
    };

    this.toastParams = { ...this.defaultOptions, ...options,}
    this.showToast(header, body, { ...this.defaultOptions });
  }

  showError(header: string, body: string | SafeHtml, delay?: number): void {
    // this.show('Failed', { autohide: true, delay: 1000, ...options });

    const options: ToastMessageOptions2 = {
      autohide: true,
      delay: delay || 3000,
      params: {
        title: header,
        timestamp: new Date().toLocaleTimeString(),
        bodyText: body,
        iconName: 'alert-triangle',    // feather icon for failure
        headerClass: 'text-danger fw-bold'
      }
    };

    this.toastParams = { ...this.defaultOptions, ...options,}
    this.showToast(header, body, { ...this.defaultOptions });
  }

  get getToasts(): ToastMessage2[] {
    return this.toasts;
  }
}
